import { Link } from "react-router-dom";
import { MediaType, PostText, PostUserBlock, SocialCount } from "ui";
import { FeedPostObj } from "utils/types/general.types";

export type FeedPostProps = {
    post: FeedPostObj;
    showLink?: boolean;
    isDeleted?: boolean;
};

const FeedPost = ({
    post,
    showLink = true,
    isDeleted = false
}: FeedPostProps) => {
    return (
        <div className="card is-post relative">
            {/* <!-- Main wrap --> */}
            {showLink && (
                <Link
                    to={`/post/${post.id}`}
                    className="absolute float-link"
                ></Link>
            )}
            <div className={`content-wrap`}>
                {/* <!-- Post header --> */}
                <div className="card-heading">
                    {/* <!-- User meta --> */}
                    <PostUserBlock user={post.user} time={post.time} />
                    {/* Right side dropdown */}
                    {/* <FeedPostDropDown /> */}
                </div>
                {/* <!-- /Post header --> */}

                {/* <!-- Post body --> */}
                <div className="card-body">
                    {/* <!-- Post body text --> */}
                    <PostText text={post.text} />
                    {/* <!-- Featured image --> */}
                    <MediaType mediaType={post.mediaType} />

                    {/* <PostActions setOpenComments={setOpenComments} /> */}
                </div>
                {/* <!-- /Post body --> */}

                {/* <!-- Post footer --> */}
                <div className="card-footer">
                    {/* <!-- Post statistics --> */}
                    <SocialCount
                        counts={post.socialCount}
                        postId={post.id}
                        isDeleted={isDeleted}
                    />
                </div>
                {/* <!-- /Post footer --> */}
            </div>
        </div>
    );
};

export default FeedPost;
